import styled from "styled-components";

export const ModalTech = styled.div`
    position: fixed;

    display: flex;
    align-items: center;
    justify-content: center;

    width:100%;
    height: 100vh;
    background: rgba(0,0,0,.50);
`

export const DivCadastro = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: #212529;
    width: 369px;
    height: 300px;
    border-radius: 4px;

    .HeaderCadastro{
        display: flex;
        flex-direction: row;
        height: 30px;
        background-color: #343B41;
        justify-content: space-between;
        align-items: center;
        padding: 15px;
        border-radius: 4px 4px 0 0;
        h3{
        color: #F8F9FA;
        font-weight: 700;
        font-size: 14px;
        }
        button{
            cursor: pointer;
            background: #343B41;
            border: none;
            color: #868E96;
        }
    }

`

export const FormCadastro = styled.form`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;

    color: #F8F9FA;
    font-weight: 400;
    font-size: 16.2426px;
    line-height: 26px;
    margin: 20px 10px;
    gap: 15px;

    div{
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }
    label{
        font-weight: 400;
        font-size: 12.182px;

        text-align: left;
    }

    input{
        background: #343B41;
        border-radius: 4px;
        padding: 10.5px;
        width: 94%;
        max-height: 40px;
        min-height: 30px;
        border: none;    
}

    .inputSelectModule{
        background-color: #343B41;
        border-radius: 4px;
    }
    .MuiInputLabel-root{
        color: #F8F9FA;
    }
    .MuiSvgIcon-root{
        color: #F8F9FA;
    }    
    .MuiSelect-select{
        color: #F8F9FA;
    }

` ;

